import React, { useCallback, useMemo, createElement } from 'react';
import ReactFlow, { 
  useNodesState, 
  useEdgesState, 
  addEdge, 
  ReactFlowProvider, 
  MiniMap,
  Controls,
  useStore,
} from 'reactflow';

import { useState } from 'react';

import 'reactflow/dist/style.css';

import TimelineNode from './TimelineNode.js';
// import TimelineEdge from './TimelineEdge.js';

// import $ from 'jquery';







const highlightPath = (arm_colors_db, arm_id, path, pathselected, color) => {

  document.querySelectorAll(path).forEach(path => {

    if (path.classList.contains(pathselected)) {

      path.classList.remove(pathselected);
      // uncheck checkbox
      document.getElementById("checkbox"+arm_id).checked = false;


      // if arm colors by another pathselected, revert to that color
      var hasPathSelected = false;
      var otherPathSelected = ''
      for (var c = 0; c < path.classList.length ; c ++){
        if (path.classList[c].startsWith('path-selected')) {
          hasPathSelected = true;
          otherPathSelected = path.classList[c];
        }
      }
      
      if (hasPathSelected){
        // get color of otherPathSelected
        var strokeColor = '#b1b1b7'
        arm_colors_db.map(color => {
          if (color.arm_id_normalized === otherPathSelected.split('path-selected-')[1]) {
            strokeColor = color.arm_color;
          }
        })

        path.style.stroke = strokeColor;
        path.style.strokeWidth = '5px';
        path.style.strokeDasharray = 'none !important';
      }

      else {
        // otherwise reverse to normal color
        path.style.stroke = '#b1b1b7';
        path.style.strokeWidth = '1px';
        path.style.strokeDasharray = '5px';
      }
    }

    else {

      path.classList.add(pathselected);
      // color path in arm color
      path.style.stroke = color;
      path.style.strokeWidth = '5px';
      path.style.strokeDasharray = 'none !important';

      // check checkbox
      document.getElementById("checkbox"+arm_id).checked = true;

    }

  });

}

const minimapStyle = {
  height: 120
};

// function to add clicked nodes to the compare list
const onCompareClick = (event, node, list, setlist, parentCallback) => {

  // if node in list, then remove
  if (list.filter(e => e === node.id).length > 0) { 
    list = list.filter(e => e !== node.id);
  }

  // else add node to list
  else {
    list.push(node.id);
  }

  // use setlist to change the state of compareNodesList
  // use setlist([...list]) instead of setlist(list), to specifically tell the component it is a new object and it needs to rerender
  setlist([...list]); 
  parentCallback([...list]);

}




// TIMELINE COMPONENT

const Timeline = (props) => {
  
  // custom node and edge type for timeline
  const nodes_db = useMemo(() => {return props.nodes}, [props.nodes]);
  const edges_db = useMemo(() => {return props.edges}, [props.edges]);
  const arm_colors_db = useMemo(() => {return props.arm_colors}, [props.arm_colors]);

  
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const onConnect = useCallback((params) => setEdges((els) => addEdge(params, els)), []);
  const proOptions = { hideAttribution: true };
  
  const nodeTypes = useMemo(() => ({ TimelineNode: TimelineNode }), []); 
  // const edgeTypes = { TimelineEdge: TimelineEdge };


  // create compareNodesList
  const compare_nodes_list = useMemo(() => {return props.compare_nodes_list}, [props.compare_nodes_list]);
  const compare_nodes_callback = useMemo(() => {return props.compare_nodes_callback}, [props.compare_nodes_callback]);
  
  const [compareNodesList, setcompareNodesList] = useState(compare_nodes_list);


  // create nodes and edges
  const build_nodes_from_file = useCallback(() => {
    if (nodes!==undefined) {
      if (nodes.length < nodes_db.length){
        for (const n of nodes_db){
          setNodes((nds) => nds.concat(n));  
        }  
      }
    }
  }, [setNodes, nodes_db, nodes]);


  const build_edges_from_file = useCallback(() => {
    if (nodes!==undefined) {
      if (edges.length < edges_db.length){
        for (const e of edges_db){
          setEdges((eds) => eds.concat(e));  
        }  
      }
    }
  }, [setEdges, edges_db, edges]);

  build_nodes_from_file();
  build_edges_from_file();  



  // zoom features
  const isMaxZoom = useStore((store) => store.transform[2] === store.maxZoom);
  const isMinZoom = useStore((store) => store.transform[2] === store.minZoom);

  // const fitviewclick = $('#'+props.id+' .react-flow__controls-fitview')[0];
  // if (fitviewclick != undefined){
  //   fitviewclick.click();
  // }


  
  return (

    <div id={props.id} className={props.display ? "TimeLine timeline-displayed" : "TimeLine"}>

      <ReactFlow
        nodeTypes={nodeTypes}
        // edgeTypes={edgeTypes}
        nodes={nodes}
        edges={edges}
        onNodeClick={(event, node) => onCompareClick(event, node, compareNodesList, setcompareNodesList, compare_nodes_callback)}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        proOptions={proOptions}
        panOnScroll={true}
        attributionPosition="top-right"
      >

        <MiniMap style={minimapStyle} zoomable pannable />
        <Controls
          className={[
            isMaxZoom ? "zoom-in-disabled" : "",
            isMinZoom ? "zoom-out-disabled" : ""
          ].join(" ")}
        />

      </ReactFlow>


      <div className="flowchart-legend">

        { (arm_colors_db !== undefined && arm_colors_db.length > 0) ? 

          arm_colors_db.map(color => (
        
            <div id={"legend-"+color.arm_id_normalized} className="legend-tile" onClick={() => { highlightPath(arm_colors_db, color.arm_id_normalized, '.color-'+color.arm_id_normalized+' path', 'path-selected-'+color.arm_id_normalized, color.arm_color) }}>
              <div className="rect" style={{ background: color.arm_color }}></div>
              <p>{color.arm_id}</p>
            </div>

          ))  
        
          : 
          
          ''
        
        }

        <div id="legend-t0" className="legend-tile">
          <div className="circle"></div>
          <p>t0</p>
        </div>

      </div>
    
    </div>

  );
};


// wrapping with ReactFlowProvider is done outside of the component
function FlowWithProvider(props) {
  return (
    <ReactFlowProvider>
      <Timeline {...props} />
    </ReactFlowProvider>
  );
}


export default FlowWithProvider;
// export default Timeline;

